export const KickstartLocked = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="50"
    viewBox="0 0 50 50"
  >
    <g
      id="Kickstart_Donor_Badge_-_Locked"
      data-name="Kickstart Donor Badge - Locked"
      transform="translate(1 -5)"
    >
      <g id="Group_2665" data-name="Group 2665" transform="translate(0 6)">
        <circle
          id="Ellipse_54"
          data-name="Ellipse 54"
          cx="24"
          cy="24"
          r="24"
          fill="#e6e6e6"
          stroke="#666"
          strokeLinecap="round"
          strokeWidth="2"
        />
        <path
          id="Path_2047"
          data-name="Path 2047"
          d="M50.221,56.935a3.54,3.54,0,0,0-3.284-2.271h-.078a3.592,3.592,0,0,0-2.289.81,3.664,3.664,0,0,0-2.258-.818,3.779,3.779,0,0,0-1.425.292A3.514,3.514,0,0,0,38.822,57.2a3.8,3.8,0,0,0,.086,2.717,7.242,7.242,0,0,0,2.07,2.725c.967.834,1.978,1.64,2.871,2.351a1.169,1.169,0,0,0,.721.313,1.282,1.282,0,0,0,.759-.325c.553-.42,1.093-.862,1.614-1.29l.105-.086a14.3,14.3,0,0,0,2.284-2.173A4.528,4.528,0,0,0,50.221,56.935ZM48.1,60.467A12.955,12.955,0,0,1,46.056,62.4l-.1.086c-.445.364-.9.739-1.366,1.1-.82-.654-1.725-1.381-2.585-2.122a5.737,5.737,0,0,1-1.643-2.132,2.249,2.249,0,0,1-.05-1.628,1.964,1.964,0,0,1,1.169-1.3,2.23,2.23,0,0,1,.837-.177,2.108,2.108,0,0,1,1.3.494l.978.752.96-.775a2.029,2.029,0,0,1,1.305-.463h.048a1.974,1.974,0,0,1,1.857,1.277A3.076,3.076,0,0,1,48.1,60.467Z"
          transform="translate(-20.853 -28.114)"
          fill="#666"
        />
        <g
          id="Group_2625"
          data-name="Group 2625"
          transform="translate(12 8.39)"
        >
          <path
            id="Path_2048"
            data-name="Path 2048"
            d="M51.014,54.265,50.63,49.55a6.927,6.927,0,0,0-3.454-5.57A8.778,8.778,0,0,0,42.794,43c-1.012,0-2.021.1-2.979.189l-.334.032c-.2.019-.39.027-.586.027h-.32c-.2,0-.391-.008-.587-.027l-.333-.032C36.7,43.1,35.688,43,34.676,43a8.783,8.783,0,0,0-4.383.98,6.939,6.939,0,0,0-3.456,5.591l-.387,4.761a3.222,3.222,0,0,0,1.483,2.976l3.4,2.021a.783.783,0,1,0,.8-1.346l-3.378-2.005a1.648,1.648,0,0,1-.748-1.519l.385-4.738a5.358,5.358,0,0,1,2.665-4.376,7.374,7.374,0,0,1,3.64-.777c.942,0,1.9.092,2.8.179l.335.032c.246.023.488.034.735.034h.32c.246,0,.49-.011.734-.034l.335-.032c.906-.087,1.862-.179,2.8-.179a7.381,7.381,0,0,1,3.641.776A5.344,5.344,0,0,1,49.072,49.7l.382,4.693a1.652,1.652,0,0,1-.776,1.539l-3.8,2.037a.782.782,0,1,0,.739,1.379l3.832-2.053A3.236,3.236,0,0,0,51.014,54.265Z"
            transform="translate(-26.44 -30.929)"
            fill="#666"
          />
          <path
            id="Path_2049"
            data-name="Path 2049"
            d="M44.781,31.25a5.693,5.693,0,1,0-5.693-5.693A5.7,5.7,0,0,0,44.781,31.25Zm0-9.821a4.128,4.128,0,1,1-4.128,4.128A4.133,4.133,0,0,1,44.781,21.429Z"
            transform="translate(-32.368 -19.864)"
            fill="#666"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const KickstartUnLocked = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="50"
    height="55"
    viewBox="0 0 50 55"
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="0.5"
        x2="0.5"
        y2="1"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#d11947" />
        <stop offset="1" stopColor="#8d0034" />
      </linearGradient>
    </defs>
    <g
      id="Kickstart_Donor_Badge_-_Unlocked"
      data-name="Kickstart Donor Badge - Unlocked"
      transform="translate(1)"
    >
      <g id="Group_2665" data-name="Group 2665" transform="translate(0 6)">
        <circle
          id="Ellipse_54"
          data-name="Ellipse 54"
          cx="24"
          cy="24"
          r="24"
          stroke="#8d0034"
          strokeLinecap="round"
          strokeWidth="2"
          fill="url(#linear-gradient)"
        />
        <path
          id="Path_2045"
          data-name="Path 2045"
          d="M48.343,57.664h-.048a2.029,2.029,0,0,0-1.305.463l-.96.775-.978-.752a2.108,2.108,0,0,0-1.3-.494,2.23,2.23,0,0,0-.837.177,1.964,1.964,0,0,0-1.169,1.3,2.249,2.249,0,0,0,.05,1.628,5.737,5.737,0,0,0,1.643,2.132c.859.741,1.765,1.468,2.585,2.122.464-.359.921-.734,1.366-1.1l.1-.086A12.955,12.955,0,0,0,49.537,61.9a3.076,3.076,0,0,0,.663-2.96A1.973,1.973,0,0,0,48.343,57.664Z"
          transform="translate(-21.478 -29.549)"
          fill="none"
        />
        <path
          id="Path_2046"
          data-name="Path 2046"
          d="M46.216,31.12a4.128,4.128,0,1,0-4.128-4.128A4.133,4.133,0,0,0,46.216,31.12Z"
          transform="translate(-21.705 -12.909)"
          fill="none"
        />
        <path
          id="Path_2047"
          data-name="Path 2047"
          d="M50.221,56.935a3.54,3.54,0,0,0-3.284-2.271h-.078a3.592,3.592,0,0,0-2.289.81,3.664,3.664,0,0,0-2.258-.818,3.779,3.779,0,0,0-1.425.292A3.514,3.514,0,0,0,38.822,57.2a3.8,3.8,0,0,0,.086,2.717,7.242,7.242,0,0,0,2.07,2.725c.967.834,1.978,1.64,2.871,2.351a1.169,1.169,0,0,0,.721.313,1.282,1.282,0,0,0,.759-.325c.553-.42,1.093-.862,1.614-1.29l.105-.086a14.3,14.3,0,0,0,2.284-2.173A4.528,4.528,0,0,0,50.221,56.935ZM48.1,60.467A12.955,12.955,0,0,1,46.056,62.4l-.1.086c-.445.364-.9.739-1.366,1.1-.82-.654-1.725-1.381-2.585-2.122a5.737,5.737,0,0,1-1.643-2.132,2.249,2.249,0,0,1-.05-1.628,1.964,1.964,0,0,1,1.169-1.3,2.23,2.23,0,0,1,.837-.177,2.108,2.108,0,0,1,1.3.494l.978.752.96-.775a2.029,2.029,0,0,1,1.305-.463h.048a1.974,1.974,0,0,1,1.857,1.277A3.076,3.076,0,0,1,48.1,60.467Z"
          transform="translate(-20.853 -28.114)"
          fill="#fff"
        />
        <g
          id="Group_2625"
          data-name="Group 2625"
          transform="translate(12 8.39)"
        >
          <path
            id="Path_2048"
            data-name="Path 2048"
            d="M51.014,54.265,50.63,49.55a6.927,6.927,0,0,0-3.454-5.57A8.778,8.778,0,0,0,42.794,43c-1.012,0-2.021.1-2.979.189l-.334.032c-.2.019-.39.027-.586.027h-.32c-.2,0-.391-.008-.587-.027l-.333-.032C36.7,43.1,35.688,43,34.676,43a8.783,8.783,0,0,0-4.383.98,6.939,6.939,0,0,0-3.456,5.591l-.387,4.761a3.222,3.222,0,0,0,1.483,2.976l3.4,2.021a.783.783,0,1,0,.8-1.346l-3.378-2.005a1.648,1.648,0,0,1-.748-1.519l.385-4.738a5.358,5.358,0,0,1,2.665-4.376,7.374,7.374,0,0,1,3.64-.777c.942,0,1.9.092,2.8.179l.335.032c.246.023.488.034.735.034h.32c.246,0,.49-.011.734-.034l.335-.032c.906-.087,1.862-.179,2.8-.179a7.381,7.381,0,0,1,3.641.776A5.344,5.344,0,0,1,49.072,49.7l.382,4.693a1.652,1.652,0,0,1-.776,1.539l-3.8,2.037a.782.782,0,1,0,.739,1.379l3.832-2.053A3.236,3.236,0,0,0,51.014,54.265Z"
            transform="translate(-26.44 -30.929)"
            fill="#fff"
          />
          <path
            id="Path_2049"
            data-name="Path 2049"
            d="M44.781,31.25a5.693,5.693,0,1,0-5.693-5.693A5.7,5.7,0,0,0,44.781,31.25Zm0-9.821a4.128,4.128,0,1,1-4.128,4.128A4.133,4.133,0,0,1,44.781,21.429Z"
            transform="translate(-32.368 -19.864)"
            fill="#fff"
          />
        </g>
      </g>
      <g id="Group_2668" data-name="Group 2668" transform="translate(31)">
        <circle
          id="Ellipse_55"
          data-name="Ellipse 55"
          cx="8.5"
          cy="8.5"
          r="8.5"
          fill="#008a1c"
        />
        <g
          id="Check_Mark_-_S"
          data-name="Check Mark - S"
          transform="translate(4 5.29)"
        >
          <path
            id="Check_Mark_-_S-2"
            data-name="Check Mark - S"
            d="M9.381,2.22a.442.442,0,0,0-.639,0L3.572,7.414,1.262,5.136a.442.442,0,0,0-.631,0,.459.459,0,0,0,0,.639l2.63,2.6a.483.483,0,0,0,.32.131.459.459,0,0,0,.32-.139l5.481-5.53A.451.451,0,0,0,9.381,2.22Z"
            transform="translate(-0.502 -2.083)"
            fill="#fff"
          />
        </g>
      </g>
    </g>
  </svg>
);
